import { withDependentModelValues } from '../withDependentModelValues';
import { DateElement } from '../DateElement/DateElement';

export const PreferredEndDate = withDependentModelValues(DateElement, [{ preferredStartDate: 'value' }, null]);
